import { LiteSiteTranslations } from '../../models/types/translations';

const defaultTranslations: LiteSiteTranslations = {
  onboardingMessage: `You’re viewing a text-only version of this website that uses less data. View the main version of the website including all images and videos.`,
  toMainSite: 'Take me to the main website',
  informationPage: 'Find out more about this data-saving version',
  dataSaving: 'Data saving version',
};

export default defaultTranslations;
